module.exports = __webpack_public_path__ + "img/migu-music.6f47631a.webp";